function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "_clipPath_6Ruu8yP0MX5gTNZOcVdW8g3LEwih5s5R"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1000,
  height: 1000
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#_clipPath_6Ruu8yP0MX5gTNZOcVdW8g3LEwih5s5R)"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 0 1000 L 1000 1000 L 1000 0 L 0 0 L 0 1000 Z ",
  fill: "rgb(255,87,87)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 0 489.003 L 0 1000 L 275.354 1000 L 589.982 766.765 L 511.858 661.38 L 590.6 603.009 L 510.783 495.339 L 582.771 441.974 L 548.039 395.122 L 583.177 369.074 L 485.022 236.664 L 449.883 262.713 L 398.593 193.524 L 0 489.003 Z ",
  fill: "rgb(0,194,203)"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "_clipPath_5d50S5bct0osaGE8KmAWdu4jAkzy6swb"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 0 1000 L 1000 1000 L 1000 0 L 0 0 L 0 1000 Z ",
  fill: "rgb(255,255,255)"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#_clipPath_5d50S5bct0osaGE8KmAWdu4jAkzy6swb)"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 423.772 192.955 L 684.95 192.955 C 684.95 192.955 694.031 193.682 689.309 201.673 C 684.586 209.665 567.62 422.166 567.62 422.166 C 567.62 422.166 606.125 435.44 633.368 500 C 660.612 564.56 663.427 717.852 577.609 775.882 C 491.792 833.911 392.896 795.497 392.896 795.497 C 392.896 795.497 303.809 765.257 309.53 640.208 C 309.53 640.208 312.254 589.262 316.977 570.736 C 317.704 567.103 316.977 562.744 322.062 562.744 C 327.148 562.744 431.764 563.107 431.764 563.107 C 431.764 563.107 436.486 560.201 434.307 574.368 C 432.127 588.535 425.588 652.104 425.588 652.104 C 425.588 652.104 421.593 690.972 463.73 688.429 C 505.867 685.887 515.675 630.309 515.675 630.309 C 515.675 630.309 535.654 554.753 511.679 525.329 C 511.679 525.329 503.688 511.89 480.803 509.71 C 457.918 507.53 436.123 505.351 436.123 505.351 C 436.123 505.351 428.858 507.894 429.584 496.633 C 430.311 485.372 435.759 421.803 435.759 421.803 C 435.759 421.803 436.123 417.808 438.666 413.448 C 441.209 409.089 508.41 303.384 508.41 303.384 L 380.545 303.384 C 380.545 303.384 374.734 304.11 375.824 296.845 C 376.914 289.58 396.529 198.404 396.529 198.404 C 396.529 198.404 394.712 192.955 401.977 192.955 L 423.772 192.955 Z ",
  fill: "rgb(255,255,255)"
})));

function SvgStep3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 1000 1000",
    width: "1000pt",
    height: "1000pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step-3.f5fc29da.svg";
export { ForwardRef as ReactComponent };